// 页面只使用后端下发的有效功能；历史地址显式映射，不以网址前缀扩大权限。
export const PERMISSION_DENIED_PATH = '/permission-denied'
type Feature = {functionKey?:string;functionUrl?:string;functionType?:string;disabled?:number|string|boolean}
const pathOf = (value:any) => String(value || '').trim().split(/[?#]/)[0].replace(/\/+$/, '').toLowerCase() || '/'
const active = (rows:Feature[]) => (Array.isArray(rows) ? rows : []).filter(row => row && ![true,1,'1'].includes(row.disabled as any))
const aliases:Record<string,string[]> = {
  '/platform/wechatpay':['wechatpay'],
  '/platform/datainit':['branchdatainit'],
  '/customers/timeextention':['delaycustomerlevelaudited'],
  '/products/upsharedproducts':['productupshare','products.upshare','products.sharingfromother'],
  '/financial/depositehistories':['system.depositesettings']
}

export function firstAccessibleManagementPath(rows:Feature[], exists:(path:string)=>boolean):string {
  const menu=active(rows).find(row=>row.functionType==='MENU' && row.functionUrl
    && exists(row.functionUrl) && canAccessManagementRoute(row.functionUrl,rows))
  return menu?.functionUrl || PERMISSION_DENIED_PATH
}
const orderPaths = new Set(['bokes','physicalbokes','fabrics','decoration','tailored','tailoredbokes','tailoredmade','tailoredcloths','cloths','accessories','videoteching','physicalprinting'].map(name=>`/orders/${name}`))

export function canAccessManagementRoute(path:string, rows:Feature[], printData?:any):boolean {
  const target=pathOf(path)
  const grants=active(rows)
  const keys=new Set(grants.map(row=>String(row.functionKey || '').toLowerCase()))
  if(target===PERMISSION_DENIED_PATH || target==='/maintenance-access')return true
  if(target==='/orders/all')return grants.some(row=>orderPaths.has(pathOf(row.functionUrl)))
  if(target==='/orderprint'){
    return Boolean(printData?.orderInfo?.id || printData?.orderInfo?.orderNumber)
      && keys.has('orderprinting') && grants.some(row=>['/orders/physicalbokes','/orders/physicalprinting'].includes(pathOf(row.functionUrl)))
  }
  if(aliases[target])return aliases[target].some(key=>keys.has(key))
  // 没有业务入口的旧图标展示页不再通过登录状态直接开放。
  return grants.some(row=>pathOf(row.functionUrl)===target && target!=='/')
}
